import { defineStore } from 'pinia'
import api from '@/libs/api.js';

export const useConfigStore = defineStore('useConfigStore', {
    state: () => ({
        user: [],
        userLoaded: false,
        userConfiguration: [],
        contract: null,
    }),

    actions: {
        async fetchUser() {
            if (!this.userLoaded) {
                try {
                    await api.get('app/user-info-client').then((response) => {
                        this.setUserInfo(response.data);
                    })
                } catch (error) {
                    console.error('Failed to load user info:', error);
                }
            } else {
                console.log('User data already loaded.');
            }
        },
        setUserInfo (newData) {
            this.user = newData.user
            this.userLoaded = true;
            this.contract = newData.contract
            this.userConfiguration = newData.userConfiguration
            if (this.userConfiguration?.style) {
                this.changeColor(this.userConfiguration.style)
            }
        },
        setUser (newData) {
            this.user = newData
        },
        changeColor (item) {
            document.documentElement.style.setProperty('--color-main', item.value);
            document.documentElement.style.setProperty('--color-bg-hover', item.value + '14');
            document.documentElement.style.setProperty('--color-gd-hover', item.value);
        }
    }
})
